<script setup lang="ts">
  import { ProfileStore } from '~/stores/profile'
  import { SiteStore } from '~/stores/site'

  const props = defineProps<{
    id: string
    action: 'shop' | 'apply'
  }>()

  const { getComponentContent } = Cms.use()
  const { content } = await getComponentContent('SomeoneElseModal')

  const profile = ProfileStore.use()

  const title = computed(() => {
    let rawTitle

    switch (props.action) {
      case 'shop':
        rawTitle = content.value.ext?.shopping_title
        break
      case 'apply':
        rawTitle = content.value.ext?.applying_title
        break
    }

    return !_isNil(profile.firstName)
      ? rawTitle.replace('{{name}}', `, ${profile.firstName}`)
      : rawTitle.replace('{{name}}', '')
  })

  const body = computed(() => {
    switch (props.action) {
      case 'shop':
        return content.value.ext?.shopping_body
      case 'apply':
        return content.value.ext?.applying_body
    }
  })

  const selection = ref<boolean | null>(null)

  const { show, hide } = DialogController.use()

  const { track } = Analytics.use()

  const { signOut } = Auth.use()
  const { push } = AppRouter.use()
  const site = SiteStore.use()

  const onLogOutAndCreate = () => {
    track('ShoppingForSomeoneElse', { result: 'LogOutAndCreate' })
    signOut()
    //@ts-ignore
    push(site.journey.signUpPath)
  }

  watch(selection, (val) => {
    if (_isNil(val)) {
      return
    } else if (!!val) {
      hide(props.id)
      show(`${props.id}-create-account-modal`)
    } else if (!val) {
      hide(props.id)
    }
  })

  const onPromptHidden = () => {
    if (selection.value === null) {
      track('ShoppingForSomeoneElse', { result: 'closed' })
    } else {
      track('ShoppingForSomeoneElse', { result: selection.value })
      selection.value = null
    }
  }

  const onLogOutCtaHidden = () => {
    track('ShoppingForSomeoneElse', { result: 'LogOutCtaHidden' })
  }
</script>

<template>
  <HpModal :title="title" :id="id" size="xxl" hide-footer @hidden="onPromptHidden">
    <aside class="someone-else-modal">
      <p class="body">
        {{ body }}
      </p>
      <HpFormRadioGroup
        v-model="selection"
        button-flex
        :icons="['no', 'yes']"
        :options="[
          {
            text: 'No',
            value: false
          },
          {
            text: 'Yes',
            value: true
          }
        ]"
      />
    </aside>
  </HpModal>
  <HpModal
    :id="`${id}-create-account-modal`"
    :title="content.ext.create_account_title"
    size="xl"
    hide-footer
    @hidden="onLogOutCtaHidden"
  >
    <aside class="create-account-modal">
      <p class="body">
        {{ content.ext.create_account_body }}
      </p>
      <HpButton @click="onLogOutAndCreate">
        {{ content.ext.create_account_cta }}
      </HpButton>
    </aside>
  </HpModal>
</template>

<style scoped>
  .someone-else-modal,
  .create-account-modal {
    @apply flex w-full flex-col items-center justify-center gap-y-8;
  }
</style>
